export const arraySort = (data, key) => {
  return data?.sort(
    (firstItem, secondItem) => firstItem[key] - secondItem[key]
  );
};
